"use client";

import React from "react";
import { Gamepad2, Globe2 } from "lucide-react";
import * as CountryFlags from "country-flag-icons/react/3x2";

export const RegionIcons = ({ code }: { code: string }) => {
  const normalized = (code || "").trim().toUpperCase();
  if (!normalized || normalized === "GLOBAL" || normalized === "LATAM") {
    return <Globe2 className="h-6 w-6 text-[#548DC8]" />;
  }

  return (
    <span className="flex items-center justify-center -space-x-1">
      {normalized.split("/").map((country) => {
        const Flag = CountryFlags[country as keyof typeof CountryFlags];
        return Flag ? (
          <Flag
            key={country}
            title={country}
            className="h-5 w-7 rounded-[3px] border border-white object-cover shadow-sm"
          />
        ) : (
          <Gamepad2 key={country} className="h-5 w-5 text-[#548DC8]" />
        );
      })}
    </span>
  );
};

export default RegionIcons;
